import { IUserChemicalExposureLogItem } from '../models/chemical-exposure.model';

export function chemicalExposureRegisteredByName(item: IUserChemicalExposureLogItem): string {
  const registeredBy: unknown = item.registeredBy;
  if (typeof registeredBy === 'string') {
    return registeredBy;
  }

  if (registeredBy && typeof registeredBy === 'object' && 'name' in registeredBy) {
    return String(registeredBy.name);
  }

  return '';
}
